import { fetchUtils } from "react-admin";
import config from "../config/config";
// import decodeJwt from 'jwt-decode';

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  return fetchUtils.fetchJson(url, options);
};

const setLocalStorageAuth = ( user, token ) => {
  console.log("user!", user);
  console.log("token!", token);
  localStorage.setItem("username", user.username);
  localStorage.setItem("auth", token);
  localStorage.setItem("permissions", user.role);
  localStorage.setItem(
    "institution",
    user.institution
      ? user.institution.id
      : null
  );
}

const authProvider = {
  login: async ({ username, password }) => {
    const options = {
      method: "POST",
      body: JSON.stringify({ username, password }),
    };

    options.headers = new Headers({ Accept: "application/json" });

    const url = `${config.apiUrl}/auth/login`;
    const response = await httpClient(url, options);

    if (response.status !== 201) return Promise.reject();

    setLocalStorageAuth( JSON.parse(response.body).user, JSON.parse(response.body).token );

    return Promise.resolve(response.status);
  },
  logout: () => {
    localStorage.removeItem("username");
    localStorage.removeItem("auth");
    localStorage.removeItem("permissions");
    localStorage.removeItem("institution");
    return Promise.resolve();
  },
  checkAuth: () =>
    localStorage.getItem("username") ? Promise.resolve() : Promise.reject(),
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("username");
      return Promise.reject();
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  getIdentity: () =>
    Promise.resolve({
      id: "admin",
      fullName: localStorage.getItem("username"),
      username: localStorage.getItem("username"),
      institution: localStorage.getItem("institution"),
      permissions: localStorage.getItem("premissions"),
    }),
  getPermissions: () => {
    const role = localStorage.getItem("permissions");
    return role ? Promise.resolve(role) : Promise.reject();
  },
  forgotPassword: async ({ email, dni }) => {
    const options = {
      method: "POST",
      body: JSON.stringify({ email, dni }),
    };

    options.headers = new Headers({ Accept: "application/json" });

    const url = `${config.apiUrl}/password-resets`;
    const response = await httpClient(url, options);

    if (response.status !== 202) return Promise.reject();
    return Promise.resolve(response.status);
  },

  recoverPassword: async ({ email, new_password, code }) => {
    const options = {
      method: "PUT",
      body: JSON.stringify({
        email,
        password: new_password,
        token: code
      }),
    };

    options.headers = new Headers({ Accept: "application/json" });

    const url = `${config.apiUrl}/password-resets/${code}`;
    console.log("url!", url);
    const response = await httpClient(url, options);
    console.log("response!", response);
    if (response.status !== 200) return Promise.reject();
    // TODO: login with new token (API is not returning it)
    // setLocalStorageAuth( JSON.parse(response.body).json, JSON.parse(response.body).token );
    return Promise.resolve(response.status);
  },
};

export default authProvider;
